import { c as _c } from "react/compiler-runtime";
import { useMediaQuery } from '@xefi/x-react/hooks';
import { mergeTailwindClasses } from '@xefi/x-react/utils';
import type { FormikProps } from 'formik';
import { useSearchParams } from 'next/navigation';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { Entry, SurveyTaking } from '@/models/survey';
import type { SurveyTakingFormValues } from '../[surveyId]/_components/SurveyTaking';
import { SurveyTakingInfo } from './SurveyTakingInfo/SurveyTakingInfo';
type SurveyTakingLayoutProps = {
  currentPage: number;
  totalPage: number;
  children: ReactNode[];
  currentSurvey?: SurveyTaking;
  onPageChange: (next: boolean) => void;
  formik?: FormikProps<SurveyTakingFormValues>;
  handleSubmitAnswers?: (values: SurveyTakingFormValues) => void;
  entry?: Entry;
  isSubmitting: boolean;
  stopTimer: boolean;
};
export const SurveyTakingLayout = t0 => {
  const $ = _c(39);
  const {
    currentPage,
    totalPage,
    children,
    currentSurvey,
    onPageChange,
    formik,
    handleSubmitAnswers,
    entry,
    isSubmitting,
    stopTimer
  } = t0;
  const {
    t
  } = useTranslation();
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams?.has("sId");
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const surveyId = t1;
  const isMobile = useMediaQuery("(max-width:768px)");
  let t2;
  if ($[2] !== surveyId || $[3] !== t) {
    t2 = surveyId && <div className="pointer-events-none fixed inset-0 z-0 flex items-center justify-center overflow-hidden select-none"><div className="text-content1-100/40 rotate-[-30deg] text-[200px] leading-[120%] font-bold tracking-[-2px] whitespace-nowrap drop-shadow-[0_1px_2px_rgba(0,0,0,0.03)]">{t("preview")}</div></div>;
    $[2] = surveyId;
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = !isMobile && "@container";
  let t4;
  if ($[5] !== t3) {
    t4 = mergeTailwindClasses("h-auto w-screen", t3);
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = isMobile ? "w-screen flex-1 flex-col p-4" : "justify-center px-10 py-4";
  let t6;
  if ($[7] !== t5) {
    t6 = mergeTailwindClasses("bg-content1-100 flex h-dvh", t5);
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = isMobile ? "relative min-h-[calc(100vh-2rem)] rounded-lg" : "min-h-[calc(100dvh-5rem)] w-full max-w-5xl";
  let t8;
  if ($[9] !== t7) {
    t8 = mergeTailwindClasses(t7);
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== currentPage || $[12] !== currentSurvey || $[13] !== entry || $[14] !== formik || $[15] !== handleSubmitAnswers || $[16] !== isSubmitting || $[17] !== onPageChange || $[18] !== stopTimer || $[19] !== surveyId || $[20] !== totalPage) {
    t9 = <SurveyTakingInfo currentPage={currentPage} totalPage={totalPage} currentSurvey={currentSurvey} onPageChange={onPageChange} formik={formik} handleSubmitAnswers={handleSubmitAnswers} entry={entry} isPreview={surveyId} isSubmitting={isSubmitting} stopTimer={stopTimer} />;
    $[11] = currentPage;
    $[12] = currentSurvey;
    $[13] = entry;
    $[14] = formik;
    $[15] = handleSubmitAnswers;
    $[16] = isSubmitting;
    $[17] = onPageChange;
    $[18] = stopTimer;
    $[19] = surveyId;
    $[20] = totalPage;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const t10 = children[currentPage];
  let t11;
  if ($[22] !== t10) {
    t11 = <div className="dark:bg-background flex h-[calc(100dvh-7.875rem)] overflow-hidden rounded-lg bg-white">{t10}</div>;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t9) {
    t12 = <div className="flex flex-col gap-6">{t9}{t11}</div>;
    $[24] = t11;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12 || $[28] !== t8) {
    t13 = <div className={t8}>{t12}</div>;
    $[27] = t12;
    $[28] = t8;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t13 || $[31] !== t6) {
    t14 = <div className={t6}>{t13}</div>;
    $[30] = t13;
    $[31] = t6;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t14 || $[34] !== t4) {
    t15 = <div className={t4}>{t14}</div>;
    $[33] = t14;
    $[34] = t4;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t15 || $[37] !== t2) {
    t16 = <>{t2}{t15}</>;
    $[36] = t15;
    $[37] = t2;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  return t16;
};